import { render, staticRenderFns } from "./OrderListItem.vue?vue&type=template&id=295780ec&scoped=true&"
import script from "./OrderListItem.vue?vue&type=script&lang=ts&"
export * from "./OrderListItem.vue?vue&type=script&lang=ts&"
import style0 from "./OrderListItem.vue?vue&type=style&index=0&id=295780ec&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295780ec",
  null
  
)

export default component.exports